import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function MyRedirectComponent() {
  const navigate = useNavigate();
  const redirectionMap = {
    "/nvq-level-courses/nvq": "/construction-nvqs",
    "/nvq-level-courses/health-and-safety": "/health-and-safety-nvqs",
    "/nvq-level-3-health&safety": "/ohs-level-3",
    "/nvq-level-6-health&safety-practice": "/ohs-level-6",
    "/nvq-level-7-Strategic-Health-and-Safety-Leadership-and-Management":
      "/ohs-level-7",
    "/the-director-role-for-health-and-safety": "/citb-drhs-course",
    "/static/js/6512.d8030e43.chunk.js:1:6848": "/",
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (redirectionMap[currentPath]) {
      navigate(redirectionMap[currentPath], { replace: true });
    }
  }, [navigate, redirectionMap]);

  return null;
}

export default MyRedirectComponent;
